<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted phone column -->
      <template #cell(phone)="data">
        <span
          class="d-block"
          style="direction: ltr"
        >{{ data.value }}</span>
      </template>
      <!-- A custom formatted group column -->
      <template #cell(group)="data">
        <b-badge variant="success">
          {{ data.value }}
        </b-badge>
      </template>
      <!-- A custom formatted created_at column -->
      <template #cell(created_at)="data">
        <display-date-time :value="data.value" />
      </template>
      <template #cell(birthday)="data">
        <display-date-time
          :value="data.value"
          type="date"
        />
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          variant="flat-warning"
          size="sm"
          class="btn-icon rounded-circle mx-2"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no contacts to display") }}
      </h6>
    </div>
    <contacts-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
      @onItemCreated="createdItem"
      @onItemUpdated="updatedItem"
    />
    <groups-edit-modal
      :form="groupForm"
      @onItemCreated="createdItem"
      @onItemUpdated="updatedItem"
      @onHideModal="resetGroupForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../common/mixins/list'
import ContactsEditModal from '../edit/ContactsEditModal'
import GroupsEditModal from '../../groups/edit/GroupsEditModal'

export default {
  name: 'ContactsList',
  components: { GroupsEditModal, ContactsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'contacts',
      groupForm: {},
    }
  },
  methods: {
    resetGroupForm() {
      setTimeout(() => {
        this.groupForm = {}
      }, 500)
    },
  },
}
</script>

<style scoped>

</style>
